(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["grid-layout"] && !Shopify.designMode) return;
  try {
    window.addEventListener('resize', function () {
    let mosaicItemContent = document.getElementById('mosaic__item__content');
    let mobilePosition = mosaicItemContent.getAttribute('data-mobile-position');
    let desktopPosition = mosaicItemContent.getAttribute('data-desktop-position');
    if (window.innerWidth > 767) {
      mosaicItemContent.classList.remove(mobilePosition);
      mosaicItemContent.classList.add(desktopPosition);
    } else {
      mosaicItemContent.classList.remove(desktopPosition);
      mosaicItemContent.classList.add(mobilePosition);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
